import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpCloudflareService } from "src/app/services/http-cloudflare.service";
import { ToastService } from "src/app/services/toast.service";
import { environment } from "src/environments/environment";

declare const turnstile: any; // Declare turnstile globally
@Component({
	selector: "app-cloudflare",
	templateUrl: "./cloudflare.component.html",
	styleUrls: ["./cloudflare.component.scss"],
})
export class CloudflareComponent implements OnInit, AfterViewInit {
	siteKey = environment.turnstileSiteKey;
	turnstileToken: string | null = null;
	// private returnUrl: string = '/wizard'; // Default redirect path

	province: string;
	municipality: string;
	commune: string;
	capId: string;

	constructor(
		private router: Router,
		private toast: ToastService,
		private cloudflareService: HttpCloudflareService,
		private route: ActivatedRoute
	) { }

	ngAfterViewInit() {
		// Ensure the script is loaded before calling turnstile
		if (typeof turnstile !== 'undefined') {
			this.renderTurnstile();
		} else {
			// Wait for the script to load
			window.onload = () => {
				this.renderTurnstile();
			};
		}
	}

	renderTurnstile() {
		turnstile.render('#turnstile-widget', {
			sitekey: this.siteKey,
			callback: (token: string) => {
				this.turnstileToken = token; // Store the token
				console.log('Turnstile token:', token);
				// call backend to verify token
				this.verifyToken();
			},
			'error-callback': (errorCode: string) => {
				console.error('Turnstile error:', errorCode);
				this.turnstileToken = null;
			},
			'expired-callback': () => {
				console.log('Turnstile token expired');
				this.turnstileToken = null;
			}
		});
	}

	verifyToken() {
		// call backend to verify token
		this.cloudflareService.verify(this.turnstileToken).subscribe(
			(response) => {
				if (response.success) {
					const verificationData = {
						verified: true,
						timestamp: Date.now()
					};
					localStorage.setItem('turnstileData', JSON.stringify(verificationData));
					this.router.navigateByUrl(this.constructParamUrl());

				} else {
					this.toast.show("Token verification failed");
				}
			},
			(error) => {
				this.toast.show("Token verification failed: " + error.message);
			}
		);
	}

	ngOnInit(): void {
		this.route.queryParamMap.subscribe(params => {
			this.capId = params.get('capId');
			console.log('Cap ID:', this.capId);
		});
	}

	constructParamUrl(): string {
		return history.state?.returnUrl || localStorage.getItem('returnUrl') || '/wizard';
	}
}
